Vue.component('search-box', {
    props: {
        value: String,
        items: {
            type: Array,
            default: function () {
                return []
            }
        },
        min: {
            type: Number,
            default: 2,
        },
        placeholder: {
            type: String,
            default: 'Search...'
        },
        param: {
            type: String,
            default: 'fullName'
        },
        hint: {
            type: Object,
            default: function () {
                return {
                    start: 'Start typing',
                    more: 'Type at least %d letters'
                }
            }
        },
        found: {
            type: Object,
            default: function () {
                return {
                    many: 'Found %d items',
                    one: 'Found 1 item',
                    none: 'No items found'
                }
            }
        },
        readonly: Boolean
    },
    computed: {
        legend: function () {
            if (this.value.length == 0) {
                return this.hint.start
            } else {
                if (this.value.length < this.min) {
                    return this.hint.more.replace('%d', this.min)
                } else {
                    if (this.visible.length === 0) {
                        return this.found.none;
                    } else {
                        return this.visible.length == 1 ? this.found.one : this.found.many.replace('%d', this.visible.length);
                    }
                }
            }
        },
        visible: function () {
            return this.filter(this.value);
        },
        inputValue: {
            get: function () {
                return this.value;
            },
            set: function (val) {
                return val;
            }
        }
    },
    methods: {
        filter: function (value) {
            if (value.length >= this.min) {
                return this.items.filter(function (item) {
                    return item[this.param].toLowerCase().includes(value.toLowerCase());
                }, this);
            } else {
                return this.items;
            }
        },
        handleBlur: function (event) {
            this.$emit('blur', event.target.value);
        },
        handleFocus: function (event) {
            this.$emit('focus', event.target.value);
        },
        handleInput: function (event) {
            this.$emit('input', event.target.value);
            this.filter(event.target.value);
        }
    },
    template: '<div class="search-box">'
        + '<input class="inputbox" v-model="inputValue" type="text" :placeholder="placeholder" @input="handleInput" @focus="handleFocus" @blur="handleBlur">'
        + '<div class="legend">{{legend}}</div>'
        + '<ul class="results" v-if="visible.length > 0">'
        + '<li v-for="item in visible" :key="item.id">'
        + '<slot name="item" v-bind="item">{{item.name}}</slot>'
        + '</li>'
        + '</ul>'
        + '</div>'
});
